export const rules = {
	// Card titles
	"rules.card.rules.title": "Reglas",
	"rules.card.pointsAllocation.title": "Asignación de Puntos",
	"rules.card.rulesContinued.title": "Reglas (continuación)",
	"rules.card.weeklyPrizes.title": "Estructura de Premios Semanales",

	// Main rules content
	"rules.intro":
		'Todos los términos en mayúsculas utilizados en estas reglas (las <strong>"Reglas"</strong>) llevarán la definición atribuida a los mismos en los términos y condiciones (los <strong>"Términos y Condiciones"</strong>).',

	"rules.temporary_notice":
		"Tenga en cuenta que los ganadores de premios durante el período del 19 de diciembre de 2025 al 2 de enero de 2026 recibirán sus premios dentro de los 7 (siete) días a partir del 6 de enero de 2026",

	"rules.rule1":
		"Los participantes pueden ganar puntos prediciendo correctamente el resultado de cada uno de los cinco (5) juegos cada semana/ronda (según sea el caso), relevante a la competencia deportiva a la que se relaciona el juego Betway Scores BW ScorePredict, por ejemplo, <em>Premier League inglesa</em>, etc. La competencia Betway Scores BW Score Predict comenzará el 11 de marzo de 2025 y concluirá al final de la temporada de fútbol 2025/2026.",

	"rules.rule2.main":
		"Los participantes pueden ganar puntos de bonificación adicionales prediciendo correctamente lo siguiente en cada uno de los cinco (5) juegos:",
	"rules.rule2.a": "Resultado final correcto",
	"rules.rule2.b": "Ganador correcto",
	"rules.rule2.c": "Goles locales correctos",
	"rules.rule2.d": "Goles visitantes correctos",
	"rules.rule2.e": "Diferencia de goles correcta",

	"rules.rule3": "Cada semana/ronda se correlaciona con las rondas de esa competencia deportiva.",

	"rules.rule4":
		"Los puntos se asignan de la siguiente manera para cada una de las siguientes predicciones correctas del Participante cada semana/ronda:",

	// Points allocation
	"rules.points.correctScore": "Resultado final correcto",
	"rules.points.correctScoreValue": "50",
	"rules.points.correctWinner": "Ganador correcto",
	"rules.points.correctWinnerValue": "5",
	"rules.points.homeGoals": "Goles locales correctos",
	"rules.points.homeGoalsValue": "5",
	"rules.points.awayGoals": "Goles visitantes correctos",
	"rules.points.awayGoalsValue": "5",
	"rules.points.goalDifference": "Diferencia de goles correcta",
	"rules.points.goalDifferenceValue": "5",

	// Continued rules
	"rules.rule5":
		"Los participantes pueden hacer cambios a sus predicciones en cualquier momento, hasta 15 minutos antes del inicio de cada uno de los juegos de la semana/ronda relevante.",

	"rules.rule6":
		"Todos los usuarios registrados de Betway Scores y/o BW Scores son elegibles para jugar Betway Scores BW ScorePredict, sin embargo, solo los participantes con una cuenta Betway verificada, en el momento en que se otorguen los premios, son elegibles para ganar premios. Los cambios en los resultados del juego según el punto 2. anterior que ocurran después de otorgar los premios (por ejemplo, anulación del resultado) no se considerarán en retrospectiva.",

	"rules.rule7":
		"El Participante calificado y elegible que termine la temporada en primer lugar y tenga una Cuenta Betway será el ganador del Gran Premio de la temporada y ganará un viaje para dos (2) para ver jugar al Arsenal en Londres, incluyendo vuelos (si es necesario), alojamiento (si es necesario) y £500 de dinero para gastos.",

	"rules.rule8":
		"Si el ganador del Gran Premio de la temporada no puede viajar debido a no tener un pasaporte válido y/o visa y/o cualquier otra limitación, recibirá un premio de €5,000 de saldo en efectivo, o el equivalente aproximado en moneda local en la fecha de inicio de la competencia (siendo £4,500, R100,000 o GH₵ 60,000), en su Cuenta Betway al completarse la competencia.",

	"rules.rule9":
		"El ganador del Gran Premio de la temporada puede optar por no tomar la experiencia y en su lugar aceptar un premio de €5,000 de saldo en efectivo, o el equivalente aproximado en moneda local en la fecha de inicio de la competencia (siendo £4,500, R100,000 o GH₵ 60,000), en su Cuenta Betway.",

	"rules.rule10":
		'Los Premios Semanales se asignarán a los "Top 10" mejores cada semana/ronda que tengan una Cuenta de Apuestas Betway válida. Si un participante del Top 10 no tiene una Cuenta de Apuestas Betway, no se le otorgará un Premio Semanal.',

	"rules.rule11":
		"Los puestos semanales del 1 al 10 ganarán las siguientes cantidades de saldo en efectivo, dependiendo de su región, en su Cuenta Betway.",

	"rules.rule12":
		"Los Premios Semanales se otorgarán dentro de 7 (siete) días de que se finalicen los resultados de esa semana y el Gran Premio se otorgará dentro de 7 (siete) días de la conclusión de la competencia Betway Scores BW Score Predict.",

	"rules.rule13":
		"En caso de empate para los Premios Semanales, el saldo en efectivo para esa posición (y las posiciones relevantes debajo de ella que se vean afectadas por el empate) se dividirá equitativamente entre los participantes empatados.",

	"rules.rule14":
		"En caso de empate para el Gran Premio, se utilizará un mecanismo aleatorizador para seleccionar solo a uno de los participantes empatados como ganador del Gran Premio.",

	// Weekly prize table data
	"rules.weeklyPrizes.position1.eur": "€150",
	"rules.weeklyPrizes.position1.gbp": "£150",
	"rules.weeklyPrizes.position1.zar": "R3000",
	"rules.weeklyPrizes.position1.ghs": "GH₵2000",

	"rules.weeklyPrizes.position2.eur": "€100",
	"rules.weeklyPrizes.position2.gbp": "£100",
	"rules.weeklyPrizes.position2.zar": "R2000",
	"rules.weeklyPrizes.position2.ghs": "GH₵1250",

	"rules.weeklyPrizes.position3.eur": "€75",
	"rules.weeklyPrizes.position3.gbp": "£75",
	"rules.weeklyPrizes.position3.zar": "R1500",
	"rules.weeklyPrizes.position3.ghs": "GH₵1000",

	"rules.weeklyPrizes.position4.eur": "€50",
	"rules.weeklyPrizes.position4.gbp": "£50",
	"rules.weeklyPrizes.position4.zar": "R1000",
	"rules.weeklyPrizes.position4.ghs": "GH₵600",

	"rules.weeklyPrizes.position5.eur": "€40",
	"rules.weeklyPrizes.position5.gbp": "£40",
	"rules.weeklyPrizes.position5.zar": "R800",
	"rules.weeklyPrizes.position5.ghs": "GH₵500",

	"rules.weeklyPrizes.position6.eur": "€30",
	"rules.weeklyPrizes.position6.gbp": "£30",
	"rules.weeklyPrizes.position6.zar": "R600",
	"rules.weeklyPrizes.position6.ghs": "GH₵400",

	"rules.weeklyPrizes.position7.eur": "€20",
	"rules.weeklyPrizes.position7.gbp": "£20",
	"rules.weeklyPrizes.position7.zar": "R400",
	"rules.weeklyPrizes.position7.ghs": "GH₵250",

	"rules.weeklyPrizes.position8.eur": "€15",
	"rules.weeklyPrizes.position8.gbp": "£15",
	"rules.weeklyPrizes.position8.zar": "R300",
	"rules.weeklyPrizes.position8.ghs": "GH₵200",

	"rules.weeklyPrizes.position9.eur": "€10",
	"rules.weeklyPrizes.position9.gbp": "£10",
	"rules.weeklyPrizes.position9.zar": "R200",
	"rules.weeklyPrizes.position9.ghs": "GH₵100",

	"rules.weeklyPrizes.position10.eur": "€10",
	"rules.weeklyPrizes.position10.gbp": "£10",
	"rules.weeklyPrizes.position10.zar": "R200",
	"rules.weeklyPrizes.position10.ghs": "GH₵100",

	// Table headers
	"rules.weeklyPrizes.header.position": "# Por Ronda",
	"rules.weeklyPrizes.header.eur": "EUR",
	"rules.weeklyPrizes.header.gbp": "GBP",
	"rules.weeklyPrizes.header.zar": "ZAR",
	"rules.weeklyPrizes.header.ghs": "GHS",
};
